export const ADMIN_LOGIN_ACTION = 'admin/login';
export const MAKE_ADMIN_ACTION = 'admin/make';
export const DELETE_ADMIN_ACTION = 'admin/remove';
export const GET_ADMIN_PROFILE_ACTION = 'get/profile';